// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { xIsAuthenticated } from "@pacific/App/Store/Selectors/GeneralSelectors";

export const XngPopulateApiParameter: typeof PopulateApiParameter = async props => {
    const state = props.getState();
    const contactUsForm = state.components.contactUsForm;
    const billTo = getCurrentBillToState(state).value;

    props.apiParameter = {
        topic: contactUsForm.fieldValues["topic"],
        firstName: contactUsForm.fieldValues["firstName"],
        lastName: contactUsForm.fieldValues["lastName"],
        phoneNumber: contactUsForm.fieldValues["phoneNumber"],
        emailAddress: contactUsForm.fieldValues["emailAddress"],
        message: contactUsForm.fieldValues["message"],
        companyName: contactUsForm.fieldValues["companyName"],
        customerNumber: billTo && billTo.customerNumber ? billTo.customerNumber : undefined,
        url: window.location.href,
        emailTo: `${props.parameter.emailRecipients},${contactUsForm.fieldValues["emailRecipients"]}`,
    } as any;
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
